import { useParams } from 'react-router-dom';
import { Copy, Download, Shield, Monitor } from 'lucide-react';
import { useState } from 'react';

export default function RDPAccess() {
  const { id } = useParams();
  const [copied, setCopied] = useState('');
  const creds = { host: '45.33.21.100', port: 3389, user: 'clawstinger', pass: 'xK9#mP2$vL5n' };

  const copy = (text, label) => { navigator.clipboard.writeText(text); setCopied(label); setTimeout(() => setCopied(''), 2000); };

  return (
    <div data-testid="rdp-access-page" className="max-w-4xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold text-white font-mono">RDP Access</h1>
      <p className="text-sm text-zinc-500 font-mono">Instance: {id}</p>

      {/* Browser RDP */}
      <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-6">
        <div className="flex items-center gap-3 mb-4">
          <Monitor size={20} className="text-cyan-400" />
          <h2 className="text-lg font-mono text-white font-bold">Browser-based RDP</h2>
        </div>
        <div className="bg-[#111] border border-zinc-800 rounded-sm aspect-video flex items-center justify-center mb-4">
          <div className="text-center">
            <Monitor size={48} className="text-zinc-700 mx-auto mb-3" />
            <p className="text-sm font-mono text-zinc-500">Apache Guacamole Remote Desktop</p>
            <button data-testid="rdp-connect-btn" className="mt-4 bg-cyan-500 text-black font-mono font-bold text-sm rounded-sm px-6 py-2.5 hover:bg-cyan-400 transition-all click-scale">
              Connect via Browser
            </button>
          </div>
        </div>
      </div>

      {/* Credentials */}
      <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-6">
        <h2 className="text-lg font-mono text-white font-bold mb-4">Connection Details</h2>
        <div className="space-y-3">
          {[['Host', creds.host], ['Port', String(creds.port)], ['Username', creds.user], ['Password', creds.pass]].map(([label, val]) => (
            <div key={label} className="flex items-center justify-between bg-[#111] border border-zinc-800 rounded-sm px-4 py-3">
              <div><span className="text-xs font-mono text-zinc-500 block">{label}</span><span className="text-sm font-mono text-white">{label === 'Password' ? '••••••••••' : val}</span></div>
              <button data-testid={`copy-${label.toLowerCase()}`} onClick={() => copy(val, label)} className="text-zinc-600 hover:text-emerald-400 transition-colors">
                {copied === label ? <span className="text-xs font-mono text-emerald-400">Copied!</span> : <Copy size={14} />}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Actions */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <button data-testid="rdp-download-btn" className="flex items-center gap-3 bg-[#0A0A0A] border border-zinc-800 rounded-sm p-5 hover:border-zinc-700 transition-all">
          <Download size={20} className="text-emerald-400" />
          <div className="text-left"><h3 className="text-sm font-mono text-white font-bold">Download RDP File</h3><p className="text-xs text-zinc-600">For native RDP clients</p></div>
        </button>
        <div className="flex items-center gap-3 bg-[#0A0A0A] border border-zinc-800 rounded-sm p-5">
          <Shield size={20} className="text-cyan-400" />
          <div className="text-left"><h3 className="text-sm font-mono text-white font-bold">IP Whitelist</h3><p className="text-xs text-zinc-600">Restrict access by IP address</p></div>
        </div>
      </div>
    </div>
  );
}
